import React from "react";
import { size } from "lodash";
import { IllustrationProps } from ".";

export default ({
  colors: {
    base,
    chart: { primary },
    scheme,
  },
}: IllustrationProps) => {
  const lineColor = size(scheme) === 1 ? scheme[0] : primary;

  return (
    <svg width="100%" height="100%" viewBox="0 0 440 120">
      <path
        d="M36 72v48H4V72h32zM196 1v119h-32V1h32zm160 53v66h-32V54h32zM116 13v107H84V13h32zm160 18v89h-32V31h32zM76 50v70H44V50h32zm160-10v80h-32V40h32zm160 11v69h-32V51h32zM156 0v120h-32V0h32zm160 19v101h-32V19h32zm120-6v107h-32V13h32z"
        fill={base}
      />
      <path
        fill="none"
        stroke={lineColor}
        strokeWidth={3}
        d="M4 106l201-22 93-62L436 73"
      />
    </svg>
  );
};
